<template>
  <div>
    <div class="page-header">
      <div
        class="page-header-content container-fluid header-elements-md-inline"
      >
        <div class="d-flex">
          <div class="page-title">
            <h4 class="font-weight-semibold">Net Promoter Score (NPS)</h4>
            <div class="text-muted">Selecione um período para começar!</div>
          </div>
          <a href="#" class="header-elements-toggle text-body d-md-none"
            ><i class="icon-more"></i
          ></a>
        </div>

        <div class="header-elements d-none py-0 mb-3 mb-md-0">
          <button type="button" class="btn btn-outline-dark">
            <i class="icon-file-presentation mr-2"></i> Relatórios
          </button>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <loading-data
        class="content d-flex justify-content-center align-items-center"
        v-if="isLoading"
      ></loading-data>
      <div v-else class="card">
        <datatable-home :periods="periods"></datatable-home>
      </div>
    </div>
  </div>
</template>

<script>
import LoadingData from '@/components/commons/LoadingData.vue'
import DatatableHome from '@/components/home/DatatableHome.vue'

export default {
  name: 'Home',
  data() {
    return {
      isLoading: true,
      periods: null,
    }
  },
  components: {
    LoadingData,
    DatatableHome,
  },

  methods: {
    async loadPeriods() {
      try {
        this.periods = await this.$store.dispatch('getPeriods')
        this.isLoading = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$children[0].$refs.notification.warning(error.message)
        } else {
          this.$root.$children[0].$refs.notification.danger(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },
  },
  mounted() {
    this.loadPeriods()
  },
}
</script>
